import React from "react";
import { Accordion } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { RecekTextField } from "../inputs";
export var TitleNameFilterAccordion = function (_a) {
    var id = _a.id, value = _a.value, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Accordion, { id: id, label: formatMessage({ id: "ui-br-legaldeposits.filter.name" }), separator: false },
        React.createElement(RecekTextField, { labelId: "ui-br-legaldeposits.filter.name", showLabel: false, value: value, onChange: function (e) {
                return onChange(e.target.value);
            }, placeholder: formatMessage({
                id: "ui-br-legaldeposits.filter.name.placeholder",
            }) })));
};
